import { useEffect, useState } from "react";
import { Modal, Row, Col, Button, Form, InputGroup } from "react-bootstrap";

import { BsSearch } from "react-icons/bs";
import { FaPlus } from "react-icons/fa";
import ExcercisesResumeList from "../ExcercisesResumeList";
import PatientForResumeList from "../PatientForResumeList";
import { getParticipants } from "../../services/participantService";
import { createProgram, updateProgram } from "../../services/programService";

//temporal, define name of the program somewhere
let k = 1;

const ReviewProgram = ({onHide, exercises, program, ...props}) => {

  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    getParticipants().then((participants) => {
      console.log("videos fetched", participants);
      setParticipants(participants);
    });
  }, []);

  const onAssignProgram = () => {
    let programToSave = {};
    if(program) {
      programToSave = program;
      programToSave.programVideos = [];
      programToSave.participants = [];
    } else {
      const programToSave = {
        default: false,
        name: "some - " + ++k,
        provider_id: 1,
        programVideos: [
          
        ],
        participants: []
      }
    }
    
    exercises.forEach((ex) => {
      programToSave.programVideos.push({
        id: ex.elId,
        repeat: ex.reps || 0,
        comment: "",
      })
    })

    participants.forEach((p) => {
      programToSave.participants.push(p.id);
    });

    let promise;

    if(programToSave.id) {
      promise = updateProgram(programToSave);
    } else {
      promise = createProgram(programToSave);
    }
    promise.then((res) => {
      alert("save successful");
      onHide();
    }).catch((err) => {
      alert("save error");
      console.log("error", err);
    });
  }

  return (
    <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Review Program</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={8}>
            <ExcercisesResumeList exercises={exercises}/>
          </Col>
          <Col md={4}>
            <h4>Assign program</h4>
            <div className="d-flex justify-content-between">
              <p className="pt-2">1. Select Participant</p>
              <Button size="sm" variant="outline-primary" className="btn-limber">
                <FaPlus size="1em" />
              </Button>
            </div>

            <Form.Group as={Col} className="py-2">
              <InputGroup>
                <InputGroup.Text id="inputGroupPrepend">
                  <BsSearch />
                </InputGroup.Text>
                <Form.Control type="text" placeholder="Search" aria-describedby="inputGroupPrepend" name="username" />
              </InputGroup>
            </Form.Group>

            <PatientForResumeList patients={participants}/>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onAssignProgram}>Assign Program</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReviewProgram;
